import React, { Component } from "react";
import { ProductConsumer } from "../context";
import { ButtonContainer, ButtonContainer2 } from "./Button";
import { Link } from "react-router-dom";






export default class Details extends Component {
  

  // Add a listener to prevent browser page refresh
  componentWillMount() {
    onbeforeunload = e => "Don't leave"
  }

  // Clear listener
  componentWillUnmount() {
    onbeforeunload = null
  }

  render() {
    
    return (
      <ProductConsumer>


        {value => {
          const {
            id,
            company,
            img,
            info,
            price,
            title,
            inCart,
            

          } = value.detailProduct;

          return (
            <div className="container py-5" >

              {/* title */}


              
        


              <div className="row">
                <div className="col-10 mx-auto text-center text-slanted text-blue my-5">
                  <h1>{title}</h1>
                </div>
              </div>
              {/* end of title */}
              <div className="row">
                <div className="col-10 mx-auto col-md-6 my-3">
                <img src={value.remoteUri ||    img} className="img-fluid" alt="" />
              
        
        { value.btn2? 
     
        console.log()
        :
        <progress value={value.progress} max="100"/>

      
        }
        <br/>
       
          
          
          
                </div>
                {/* prdoduct info */}
                <div className="col-10 mx-auto col-md-6 my-3 text-capitalize">
                  <h1>{title}</h1>
                  <h4 className="text-title text-uppercase text-muted mt-3 mb-2">
                    made by : <span className="text-uppercase">{company}</span>
                  </h4>
                  <h4 >
                    <strong >
                      price : <span className="text-success" style={{fontSize:18}}>Rs.{price}</span>
                      
                    </strong>
                  </h4>
                  <p className="text-capitalize font-weight-bold mt-3 mb-0">
                    some info about product :
                  </p>
                  <p className="text-muted lead">{info}</p>
                 
                  {/* buttons */}
                  <div>



                    <Link to="/" hidden>
                      <ButtonContainer>back to products</ButtonContainer>
                    </Link>




                    { value.btn?
                    <div>
              <ButtonContainer2>
         <label >
            <input type="file" hidden  onChange={value.handleChange2} />
             Browser </label>
       </ButtonContainer2>
       <ButtonContainer
       cart
       //disabled={inCart ? true : false}
       onClick={() => {
         value.openModal2(id);
         //value.addToCart(id);
         
       }}
     >Edit
       
     </ButtonContainer>
     </div>
  
                    :
                     <div>
                    <ButtonContainer
                      onClick={() => {
                      value.handleUpload(id);}
        }>Upload</ButtonContainer>
        <ButtonContainer  cart  
        onClick={value.handleChange3}
        //disabled={inCart ? true : false}
      >Cancel
      </ButtonContainer>
        </div>
                  }



{}

                   
                  </div>
                </div>
              </div>












              
            </div>
          );
        }}
      </ProductConsumer>
    );
  }
}